import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/system-config";

export const pagingSystemConfig = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getSystemConfigId = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const getByKeyCode = (code) => axios.get(API_PATH + "/get-by-key-code/" + code);

export const saveOrUpdate = shiftWork => axios.post(API_PATH + '/save-or-update', shiftWork);

export const deleteById = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllShiftWorks = () => axios.get(API_PATH + "/get-all");

export const getCheckSystemConfig = (data) => axios.post(API_PATH + "/check-code",data);
